import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import {  userSearchAPI } from 'src/api/UserApi';


const UserDropDown = ({ value, name, onChange,placeholder,...rest }) => (
    <FormikSearchDropdown
        name={name}
        placeholder={placeholder||"Select User"}
        displayKeyPath={[
            'firstName','lastName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'firstName','lastName',
        ]}
        api={userSearchAPI}
        apiCallAddonData={{
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
        }}
        value={value}
        onChange={onChange} 
        {...rest}
    />
);

UserDropDown.propTypes = {
    
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
};

UserDropDown.defaultProps = {
    value: '',
    readOnly: false,
};

export default UserDropDown;
